export const NVS_THEME_CLASS = "nvs-theme";
export const NVS_THEME_STYLE_ID = "nvs-theme-style";
